import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '红星美凯龙“守护者联盟”家居大牌强势集结，联合守护逆势破局';

const route: RouteConfig = {
  path: '/20200224SHZLM',
  name: 'SHZLM',
  component: () => import('./Home.vue'),
  redirect: '/20200224SHZLM/news',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'news',
      component: () => import('./RelativeNews.vue'),
      name: '20200224SHZLM/news',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200224SHZLM/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
